import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { firebaseConfig } from "./firebase_project_config";

export const app = initializeApp(firebaseConfig);
export const perf = getPerformance(app);
